import { PersonOutlineRounded } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EntityViewBlock, EntityViewSectionTitle } from 'shared/components/layout/entityView';

export interface PersonalInformationSectionProps {
    firstName: string;
    lastName: string;
}

export default function PersonalInformationSection({ firstName, lastName }: PersonalInformationSectionProps) {
    const { t } = useTranslation('profile');

    return (
        <>
            <EntityViewSectionTitle
                title={ t('view.sections.personalInformation') }
                icon={ <PersonOutlineRounded /> }
            />
            <EntityViewBlock title={ t('fields.fullName') }>
                <Typography variant="body2">
                    { [ firstName, lastName ].join(' ') }
                </Typography>
            </EntityViewBlock>
        </>
    );
}
